import { clientbookApi } from '../core/clientbook-api';

// A store with no existing mapping returns 404 on delete — that is a no-op, not a failure.
// Any other error (network, 5xx, auth) must surface so the save does not silently succeed.
const deleteMappingIfExists = async url => {
  try {
    await clientbookApi.delete({ url });
  } catch (error) {
    if (error?.response?.status !== 404) {
      throw error;
    }
  }
};

// An empty selection or an explicit "Unmapped" choice means the store should be unmapped.
const isUnmapped = extRefId => !extRefId || extRefId === 'unmapped';

// Google

export const getGoogleLocations = async () => {
  return clientbookApi.get({ url: '/google/locations' });
};

export const saveGoogleLocationMappings = async mappings => {
  const relevant = mappings.filter(m => m.storeId !== '0');
  for (const { storeId, accountId, extRefId, title } of relevant) {
    if (accountId && extRefId && extRefId !== 'unmapped') {
      await clientbookApi.patch({
        url: `/stores/${storeId}/google/location`,
        data: { extRefId, accountId: Number(accountId), title },
      });
    } else {
      try {
        await clientbookApi.delete({ url: `/stores/${storeId}/google/location` });
      } catch {
        // 404 means no existing mapping — nothing to delete
      }
    }
  }
};

export const uninstallGoogleIntegration = async () => {
  return clientbookApi.delete({ url: '/google/integration' });
};

// Facebook

export const getFacebookPages = async () => {
  return clientbookApi.get({ url: '/meta/facebook/pages' });
};

export const saveFacebookPageMappings = async mappings => {
  const relevant = mappings.filter(m => m.storeId !== '0');
  for (const { storeId, extRefId, accountId } of relevant) {
    if (isUnmapped(extRefId)) {
      await deleteMappingIfExists(`/stores/${storeId}/meta/facebook/page`);
    } else if (accountId) {
      await clientbookApi.patch({
        url: `/stores/${storeId}/meta/facebook/page`,
        data: { extRefId, accountId },
      });
    }
    // A page selected without an accountId is incomplete data — leave the existing mapping alone
  }
};

export const uninstallFacebookIntegration = async () => {
  return clientbookApi.delete({ url: '/meta/facebook/accounts' });
};

// Instagram

export const getInstagramAccounts = async () => {
  return clientbookApi.get({ url: '/meta/instagram/accounts' });
};

export const saveInstagramAccountMappings = async mappings => {
  const relevant = mappings.filter(m => m.storeId !== '0');
  for (const { storeId, extRefId } of relevant) {
    if (isUnmapped(extRefId)) {
      await deleteMappingIfExists(`/stores/${storeId}/meta/instagram/account`);
    } else {
      await clientbookApi.patch({
        url: `/stores/${storeId}/meta/instagram/account`,
        data: { extRefId },
      });
    }
  }
};

export const uninstallInstagramIntegration = async () => {
  return clientbookApi.delete({ url: '/meta/instagram/accounts' });
};

// Merchant

export const getBlacklistWords = async () => {
  return clientbookApi.get({ url: '/merchants/blacklistwords' });
};
